import React from 'react';
import { MarketTrendsAveragePriceResponse } from '../../types/marketTrends';

interface Options {
  lineBreak?: boolean;
}

export const getAveragePriceLabel = (
  data: MarketTrendsAveragePriceResponse,
  options?: Options,
): string | React.ReactElement => {
  let prefix = 'Average price';
  if (data.filter) {
    prefix += ` for ${data.filter}`;
  }
  prefix += ` in ${data.term}`;

  if (options?.lineBreak) {
    return (
      <>
        {prefix}
        <br />
        {data.label}
      </>
    );
  }

  return `${prefix} - ${data.label}`;
};

export default getAveragePriceLabel;
